import React from "react";
import theme from "../../../config/theme";
import Header from "../Homepage/FeaturedProducts/Header";
import SinglesGame from "./SinglesGame";

const SinglesGamePicker = () => (
  <div className="singles-game-picker-wrapper">
    <style jsx>{`
      .singles-game-picker {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: row;
      }

      .header-container {
        margin-top: 20px;
        padding: 10px;
        width: 100%;
        display: flex;
        justify-content: center;
        color: #ffffff;
        background: linear-gradient(
          to right,
          ${theme.colors.base.lightGray} 20%,
          ${theme.colors.base.gray}
        );
        background-image: url("/img/featured-bg-singles.jpg");
        background-size: auto 100%;
        box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
        box-sizing: border-box;
      }

      @media only screen and (max-width: ${theme.responsive.s}px) {
        .singles-game-picker {
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }
      }
    `}</style>
    <div className="header-container">
      <Header title="Alege un joc!" />
    </div>

    <div className="singles-game-picker">
      <SinglesGame game={3} />
      <SinglesGame game={1} />
      <SinglesGame game={6} />
    </div>
    <div className="singles-game-picker">
      <SinglesGame game={18} />
      <SinglesGame game={21} />
    </div>
  </div>
);

export default SinglesGamePicker;
